import { render, staticRenderFns } from "./RegularMediaArtDirection.vue?vue&type=template&id=640a1814&scoped=true&name=regular-media-art-direction&"
import script from "./RegularMediaArtDirection.vue?vue&type=script&lang=js&"
export * from "./RegularMediaArtDirection.vue?vue&type=script&lang=js&"
import style0 from "./RegularMediaArtDirection.vue?vue&type=style&index=0&id=640a1814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a1814",
  null
  
)

export default component.exports